import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Payload = uui.domain.actions.rpc.user.EnableUserAction['payload']

/**
 * Enable a user
 *
 * @private
 */
export const enableUser = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/user/enable', async (payload: Payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/user/enableUser', {
      category: 'rpc',
      type: 'rpc/user/enableUser',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main('Unknown error on {enableUser}', { tags: ['rpc', 'user'] }, 'error')

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Enable User Failed',
      error,
    })
  }
})
